import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth()

  // Afficher un loader pendant la vérification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    )
  }

  // Rediriger vers login si pas connecté
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Rediriger vers home si connecté mais pas admin
  if (!isAdmin()) {
    return <Navigate to="/" replace />
  }

  // Afficher le contenu protégé si tout est OK
  return children
}

export default ProtectedRoute
